import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Loading from "@client/controls/Loading/component";
import { Status, type WithIsEditMode } from "@client/types";
import * as React from "react";
import { formatValue } from "./lib";
import { type Kpi } from "./types";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    error: string | null;

    reloadHash: string;
    kpi: Kpi.Api.KpiType | null;
    aggregateValue: Kpi.AggregateValue | null;
    afterText: string;
    beforeText: string;
    textStyle: React.CSSProperties;
    status: string;
  };

export type ActionProps = {
  getAggregate: () => void;
};

export default (props: MapProps & ActionProps) => {
  React.useEffect(() => {
    props.reloadHash && props.getAggregate();
  }, [props.getAggregate, props.reloadHash]);

  return (
    <Container className="wsc_content_network_kpi" {...getContainerProps(props)}>
      {props.status === Status.Loading && <Loading isAbsolute />}
      {!!props.kpi ? (
        <div style={props.textStyle}>
          {props.beforeText}
          {formatValue(props.kpi, props.aggregateValue?.aggregate)}
          {props.afterText}
        </div>
      ) : props.isEditMode ? (
        "No KPI selected"
      ) : null}
    </Container>
  );
};
